import React, { useState, useEffect, useRef } from "react";
import "./Tecnologias-Page.css";
import TecnologiaModal from "./TecnologiaModal/TecnologiaModal";
import data from "../../Data/tecnologias.json";
import M from "materialize-css";
import AOS from "aos";
import "aos/dist/aos.css";

export default function TecnologiasPage() {
  const [modalAberto, setModalAberto] = useState(null);

  const tecnologias = data.tecnologias;

  const collapsibleRef = useRef(null);

  useEffect(() => {
    if (collapsibleRef.current) {
      M.Collapsible.init(collapsibleRef.current, {
        accordion: false,
      });
    }

    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  const handleExpandModal = (tech) => {
    setModalAberto(null);
  };

  const tecnologiaAtual = tecnologias.find((t) => t.id === modalAberto);

  return (
    <div id="page-tecnologias" className="tecnologias-main">
      <section className="tech-section-1">
        <h2 className="main-title" data-aos="fade-left">
          Tecnologias
        </h2>
        <p className="main-description" data-aos="fade-right">
          Na busca pela abordagem mais segura e eficaz, a cirurgia plástica moderna integra inovações contínuas.
          O Dr. Luciano Gazzoni utiliza tecnologias avançadas como pilares de sua prática, priorizando a precisão
          e o bem-estar do paciente. Ferramentas como o SAFER/VASER, o Laser One S.T.E.P.™ e a Plataforma IGNITE
          foram selecionadas para minimizar o trauma cirúrgico, otimizar a qualidade da pele e a recuperação.
          Nosso objetivo é potencializar o contorno corporal e a firmeza tecidual, fornecendo uma cirurgia mais
          controlada e um processo pós-operatório mais confortável e menos agressivo.
        </p>
      </section>

      <section className="tech-section-2">
        <h3 className="tech-page-title" data-aos="fade-left">
          Conheça as nossas tecnologias
        </h3>

        <div className="tech-cards-container">
          {Array.isArray(tecnologias) &&
            tecnologias.map((tech, idx) => {
              const imagem = tech.imagem || "/img/default-tech.png";
              const titulo = tech.titulo || "Tecnologia";

              return (
                <div
                  key={tech.id}
                  className="tech-card"
                  style={{ backgroundImage: `url(${imagem})` }}
                  onClick={() => setModalAberto(tech.id)}
                  data-aos="zoom-in"
                  data-aos-delay={idx * 150}
                >
                  <span className="tech-card-title">{titulo}</span>
                </div>
              );
            })}
        </div>

        {modalAberto !== null && tecnologiaAtual && (
          <TecnologiaModal
            tecnologia={tecnologiaAtual}
            onClose={() => setModalAberto(null)}
            onExpand={handleExpandModal}
          />
        )}
      </section>

      {/* <div id="perguntasTecnologias" className="container-qa" data-aos="fade-up">
        <h5 className="h5-tech-qea">Perguntas e Respostas Sobre as Tecnologias</h5>
        <ul
          className="collapsible tecnologias"
          ref={collapsibleRef}
        >
          {perguntas.map((pergunta, idx) => (
            <li key={idx} data-aos="fade-up" data-aos-delay={idx * 100}>
              <div className="collapsible-header questions-header-page-tech">
                {pergunta.pergunta}
                <i className="material-icons">keyboard_arrow_down</i>
              </div>
              <div className="collapsible-body questions-body-page-tech">
                <p className="question-page-intimas">{pergunta.resposta}</p>
              </div>
            </li>
          ))}
        </ul>
      </div> */}
    </div>
  );
}
